import {
  TASKS_TEAM_SELECTION,
  TASKS_STATUS_SELECTION,
  TASKS_FILTER_RESET,
  TASKS_FILTER_VIEW_UPDATE,
} from 'actions/tasksFilters';

export const tasksFiltersInitialState = {
  status: [],
  team: null,
  isFilterViewOpen: false,
};

const tasksFiltersReducer = (state = tasksFiltersInitialState, action) => {
  switch (action.type) {
    case TASKS_TEAM_SELECTION: {
      return { ...state, team: action.payload };
    }
    case TASKS_STATUS_SELECTION: {
      return { ...state, status: action.payload };
    }
    case TASKS_FILTER_VIEW_UPDATE: {
      return { ...state, isFilterViewOpen: action.payload };
    }
    case TASKS_FILTER_RESET: {
      return tasksFiltersInitialState;
    }
    default:
      return state;
  }
};

export default tasksFiltersReducer;
